import React from "react";

export default function TextComponent({ text }: { text: string }) {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: text }}
      className="px-3 rounded-md"
    />
  );
}
